"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicLoadManualStaticComponents = void 0;
const genericManual_1 = require("../genericManual");
class DynamicLoadManualStaticComponents extends genericManual_1.GenericLoadManualStatic {
    constructor() {
        super(...arguments);
        this.initialize = (verticalConfig) => __awaiter(this, void 0, void 0, function* () {
            return verticalConfig.entrypoint();
        });
        this.leaveVerticalConfigAvailable = (verticalId, verticalConfig) => {
            var _a, _b;
            window.globals = window.globals || {};
            window.globals[verticalId] = verticalConfig;
            (_b = (_a = window.globalPromises) === null || _a === void 0 ? void 0 : _a[verticalId]) === null || _b === void 0 ? void 0 : _b.call(_a);
            return window.globals[verticalId];
        };
    }
}
exports.DynamicLoadManualStaticComponents = DynamicLoadManualStaticComponents;
//# sourceMappingURL=dynamicLoadComponents.js.map